import React from 'react';
import { FormField } from '../../../../components/FormField';
import { FormRow } from '../../../../components/FormRow';

interface PromotionConstructionProps {
  formData: any;
  property?: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
}

export const PromotionConstruction: React.FC<PromotionConstructionProps> = ({
  formData,
  property,
  handleInputChange,
}) => {
  return (
    <div className="space-y-4">
      <h4 className="font-medium text-gray-900 dark:text-white">Planning et avancement des travaux</h4>

      <FormRow>
        <FormField label="Date de début des travaux">
          <input
            type="date"
            name="construction_start_date"
            value={property?.construction_start_date || formData.construction_start_date || ''}
            onChange={handleInputChange}
          />
        </FormField>

        <FormField label="État d'avancement (%)">
          <input
            type="number"
            name="construction_progress"
            value={property?.construction_progress ?? formData.construction_progress ?? 0}
            onChange={handleInputChange}
            min="0"
            max="100"
            placeholder="0"
          />
        </FormField>
      </FormRow>

      <FormField label="Statut d'avancement">
        <select
          name="construction_progress_status"
          value={property?.construction_progress_status || formData.construction_progress_status || ''}
          onChange={handleInputChange}
          className="w-full"
        >
          <option value="">Sélectionner</option>
          <option value="fondations">Fondations</option>
          <option value="gros œuvre">Gros œuvre</option>
          <option value="second œuvre">Second œuvre</option>
          <option value="finitions">Finitions</option>
          <option value="livré">Livré</option>
        </select>
      </FormField>

      <h4 className="font-medium text-gray-900 dark:text-white mt-6">Détails de construction</h4>

      <FormField label="Matériaux utilisés">
        <textarea
          name="building_materials"
          value={property?.building_materials || formData.building_materials || ''}
          onChange={handleInputChange}
          rows={3}
          placeholder="Ex: Béton armé, briques, etc."
          className="w-full"
        />
      </FormField>

      <FormRow>
        <FormField label="Revêtements muraux">
          <input
            type="text"
            name="wall_covering"
            value={property?.wall_covering || formData.wall_covering || ''}
            onChange={handleInputChange}
            placeholder="Ex: Peinture, faïence"
          />
        </FormField>

        <FormField label="Revêtements de sol">
          <input
            type="text"
            name="floor_covering"
            value={property?.floor_covering || formData.floor_covering || ''}
            onChange={handleInputChange}
            placeholder="Ex: Carrelage, parquet"
          />
        </FormField>
      </FormRow>

      <FormRow>
        <FormField label="Système de chauffage/climatisation">
          <input
            type="text"
            name="heating_system"
            value={property?.heating_system || formData.heating_system || ''}
            onChange={handleInputChange}
            placeholder="Ex: Climatisation centralisée"
          />
        </FormField>

        <FormField label="Type d'isolation">
          <input
            type="text"
            name="insulation_type"
            value={property?.insulation_type || formData.insulation_type || ''}
            onChange={handleInputChange}
            placeholder="Ex: Isolation phonique et thermique"
          />
        </FormField>
      </FormRow>
    </div>
  );
};
